import { type ImageCardProps } from './ImageCard.props'

export const imageCardDefaults = {
  heading: 'FPO Header',
  subheading:
    'On click, user is prompted for email and phone before viewing next step. On click, user is prompted for email and phone before viewing next step. On click, user is prompted for email and phone before viewing next step. On click, user is prompted for email and phone before viewing next step.',
  imageSrc:
    'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F6495c62d937740e9a1291ff42f6bd0b8?format=webp',
  headingColor: 'white',
  subheadingColor: 'white',
  redirectUrl: '/',
  showGradient: true,
} satisfies ImageCardProps
